import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface InvitationEmailTemplate {
  id: number;
  public_id: string;
  district: number;
  district_public_id: string;
  district_name: string;
  variant: 'shared' | 'role';
  body_html: string;
  available_variables: string[];
  created_at: string;
  updated_at: string;
}

export interface InvitationEmailTemplateListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: InvitationEmailTemplate[];
}

/**
 * Get all invitation email templates for the organization
 */
export async function getInvitationEmailTemplates(): Promise<InvitationEmailTemplate[]> {
  const result = await client.GET('/api/v2/invitation-email-templates/' as any, {});
  const data = unwrap(result) as unknown as InvitationEmailTemplateListResponse;
  return data.results || [];
}

/**
 * Create a new custom template
 */
export async function createInvitationEmailTemplate(data: {
  district: number;
  variant: 'shared' | 'role';
  body_html: string;
}): Promise<InvitationEmailTemplate> {
  const result = await client.POST('/api/v2/invitation-email-templates/' as any, {
    body: data as never,
  });
  return unwrap(result) as unknown as InvitationEmailTemplate;
}

/**
 * Update an existing custom template
 */
export async function updateInvitationEmailTemplate(
  publicId: string,
  data: { body_html: string },
): Promise<InvitationEmailTemplate> {
  const result = await client.PATCH(
    '/api/v2/invitation-email-templates/{public_id}/' as any,
    {
      params: { path: { public_id: publicId } as never },
      body: data as never,
    },
  );
  return unwrap(result) as unknown as InvitationEmailTemplate;
}

/**
 * Delete a custom template, reverting to the system default
 */
export async function deleteInvitationEmailTemplate(publicId: string): Promise<void> {
  const result = await client.DELETE(
    '/api/v2/invitation-email-templates/{public_id}/' as any,
    {
      params: { path: { public_id: publicId } as never },
    },
  );
  unwrap(result);
}
